import Consts from '@/api/Consts';

import { getTodayDayJs, addDays } from '@/components/common/dateUtils';


const getChartDays = () => {
	const maxDate = getTodayDayJs().toDate();
	const minDate = addDays(maxDate, Consts.BASE_STATION_PAGE_DAYS_COUNT);
	return { minDate, maxDate };
}

export { getChartDays };
